import Vue from 'vue';
import Router from 'vue-router';
import Login from '../view/Auth/login';
import b2bRegister from '../view/Auth/b2bRegister';
import Register from '../view/Auth/register';
import Account from '../view/account';
import Addresses from '../view/addresses';
import Blog from '../view/blog/blog';
import BlogDetail from '../view/blog/blogDetail';
import Cart from '../view/cart';
import Category2 from '../view/category2List';
import Collections from '../view/collections';
import Confirmation from '../view/confirmation';
import DriverApplication from '../view/driverApplication.vue';
import Home from '../view/Home/home';
import Index from '../view/index';
import NotFound from '../view/404';
import ProductList from '../view/productList';
import ProductDetails from '../view/productDetails';
import Purchase from '../view/purchase';
import Recipes from '../view/Recipe/recipes';
import RecipeDetail from '../view/Recipe/recipeDetail';
import ReturnsAndRefunds from '../view/returnsAndRefunds';
import Order from '../view/Profile/orderDetail.vue';
import Profile from '../view/Profile';
import Search from '../view/search.vue';
import store from '../store';
import About from '../view/Footer/about';
import Contact from '../view/Footer/contact';
import Faq from '../view/Footer/faq';
import Privacy from '../view/Footer/privacy';
import Terms from '../view/Footer/terms';
import QRCode from '../view/Footer/qrCode';

import landingList from '../view/Footer/landing';
import landing from '../view/Footer/landingPage';
Vue.use(Router);

async function validateToken (token) {
  //axios request to valida token
  return true;
}
// const guard = async (to, from, next) => {
//   try {
//     const token = localStorage.getItem('token');
//     if(token && validateToken(token)) {
//       next('/');
//     } else {
//       next();
//     }
//   } catch(err) {
//     console.log('err find in guard', err);
//   }
// };

const routeToAccount = (to, from, next) => {
  // store.dispatch('addresses/fetchAddresses');
  // store.dispatch('addresses/fetchDefaultAddress');
  store.dispatch('orders/fetchOrderByTimeFrame', 3);
  // store.dispatch('auth/fetchCustomerInformation');
  next();
}

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'index',
      component: Index,
      children: [
        {
          path: '/',
          name: 'home',
          component: Home,
        }, {
          path: '/collections/:group',
          name: 'productList',
          component: ProductList,
          props: true,
        }, {
          path: '/productDetails/:product',
          name: 'productDetails',
          component: ProductDetails,
        },{
          path: '/login',
          name: 'login',
          // beforeEnter: guard,
          component: Login,
        }, {
          path: '/cart',
          name: 'cart',
          component: Cart,
        }, {
          path: '/about-us',
          name: 'about',
          component: About,
        }, {
          path: '/blogs',
          name: 'blog',
          component: Blog,
        }, {
          path: '/blog/:blog_id',
          name: 'blogDetail',
          component: BlogDetail,
        }, {
          path: '/recipes',
          name: 'recipes',
          component: Recipes,
        }, {
          path: '/recipe/:recipe_id',
          name: 'recipeDetail',
          component: RecipeDetail,
        }, {
          path: '/contact-us',
          name: 'contact',
          component: Contact,
        }, {
          path: '/returns-and-refunds',
          name: 'returns-and-refunds',
          component: ReturnsAndRefunds,
        }, {
          path: '/terms-of-service',
          name: 'terms',
          component: Terms,
        }, {
          path: '/privacy',
          name: 'privacy',
          component: Privacy,
        }, {
          path: '/faq',
          name: 'faq',
          component: Faq,
        }, {
          path: '/qrCode',
          name: 'qrCode',
          component: QRCode
        }, {
          path: '/register',
          name: 'register',
          component: Register,
        }, {
          path: '/businessRegistration',
          name:'businessRegistration',
          component: b2bRegister,
        }, {
          path: '/account',
          name: 'account',
          component: Profile,
          beforeEnter: routeToAccount,
        }, {
          path: '/addresses',
          name: 'addresses',
          component: Addresses,
        },{
          path: '/purchase',
          name: 'purchase',
          component: Purchase,
        },
        {
          path: '/confirmation',
          name: 'confirmation',
          component: Confirmation,
        },
        {
          path: '/order/:order_id',
          name: 'order',
          component: Order,
        },
        // {
        //   path: '/collections',
        //   name: 'collections',
        //   component: Collections,
        // },
        {
          path: '/search',
          name: 'search',
          component: Search,
        },{
          path: '/category2/:cat2',
          name: 'category2',
          component: Category2,
          props: true,
        },{
          path: '/driverapplication',
          name: 'driverapplication',
          component: DriverApplication,
          props: true,
        },  
        {
          path: '/asian-food',
          name: 'landingList',
          component: landingList,
        },
        // mapping for old AFG groups
        {
          path: '/collections/noodles',
          alias: '/asian-food/noodles',
          name: 'Noodles Group',
        },
        {
          path: '/collections/munchies',
          alias: '/asian-food/snacks-candy',
          name: 'Snacks Group',
        },
        {
          path: '/collections/dranks',
          alias: '/asian-food/beverages',
          name: 'Beverages Group',
        },
        {
          path: '/collections/eats',
          alias: '/asian-food/rice-grains',
          name: 'Rice Grains Group',
        },
        {
          path: '/collections/eats',
          alias: '/asian-food/sauces-seasoning',
          name: 'Sauces Seasoning Group',
        },
        {
          path: '/collections/eats',
          alias: '/asian-food/grocery',
          name: 'Grocery Group',
        },
        {
          path: '/collections/smarts',
          alias: '/books-paper/stationery-supplies',
          name: 'Stationary Group',
        },
        {
          path: '/asian-food/*',
          name: 'landingPage',
          component: landing,
        },
        { path: '*', component: Home }
      ]
    }
  ],
  mode: 'history',
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } 
      return { x: 0, y: 0 }   
  },
})
/**
 * 重写路由的push方法
 */
const routerPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(error=> error)
}

router.beforeEach((to, from, next) => {
  // store.dispatch('fetchAccessToken');
  const token = localStorage.getItem('token');
  if (to.fullPath === '/account'||to.fullPath.includes('/order')) {
    if (!token) {
      next('/');
    }
  }
  if (to.fullPath === '/login') {
    if (token) {
      next('/account');
    }
  }
  next();
});

// returns an array with all the routes
function getRoutesList(routes, pre) {
  
  return routes.reduce((array, route) => {
    const path = `${pre}${route.path}`;

    if (route.path !== '*') {
      array.push(path);
    }

    if (route.children) {
      array.push(...getRoutesList(route.children, `${path}/`));
    }
    return array;
  }, []);
}

function getRoutesXML() {
  const list = getRoutesList(router.options.routes, 'https://www.asianfoodgrocer.com')
    .map(route => `<url><loc>${route}</loc></url>`)
    .join('\r\n');
  return `<urlset xmlns="http://www.sitemaps.org/schemas/sitemap/0.9" xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xsi:schemaLocation="http://www.sitemaps.org/schemas/sitemap/0.9 http://www.sitemaps.org/schemas/sitemap/0.9/sitemap.xsd">
    ${list}
  </urlset>`;
}

getRoutesXML();

export default router



// WEBPACK FOOTER //
// ./src/router/index.js